exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".slide-navigation[data-v-70defcf8]{display:flex;justify-content:flex-end;margin-top:10px;position:absolute;top:20px;right:20px}.slide-navigation .mdi-arrow-left[data-v-70defcf8]{margin-right:15px}\n", ""]);

